// oxlint-disable-next-line filename-export/match-named-export
import { cloneElement, type JSX, type RefObject } from 'react'

type Props = {
  condition: boolean
  wrap: (children: JSX.Element) => JSX.Element
  children: JSX.Element
  ref?: RefObject<unknown>
}

export const ConditionalWrap = ({ condition, children, wrap, ref }: Props) =>
  condition ? cloneElement(wrap(children), { ref }) : children
